import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetAllocation from '@app/views/Ledger/BudgetAllocation';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetAllocation)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
